import Sentry from '@sentry/browser';

function convert(paramName, paramVal, intOrFloat) {
    if (paramVal === undefined || paramVal === null) {
        return undefined;
    }
    if (typeof paramVal === "number") {
        return paramVal;
    }
    if (paramVal.constructor === Array) {
        const x = [];
        for (let v of paramVal) {
            const numVal = intOrFloat === "int" ? parseInt(v) : parseFloat(v);
            if (isNaN(numVal)) {
                if (v) {
                    Sentry.captureException(`invalid ${paramName}: ${v}`);
                }
                return undefined;
            }
            x.push(numVal);
        }
        return x;
    }
    const numVal = intOrFloat === "int" ? parseInt(paramVal) : parseFloat(paramVal);
    if (isNaN(numVal)) {
        if (paramVal) {
            Sentry.captureException(`invalid ${paramName}: : ${paramVal}`);
        }
        return undefined;
    }
    return numVal;
}
function validateAndConvertReqParamToInt(paramName, paramVal) {
    return convert(paramName, paramVal, "int");
}

export { validateAndConvertReqParamToInt };
//# sourceMappingURL=validateAndConvertReqParamToNum.js.map
